import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces/index';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    outerwrapper: {
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      left: 0,
      pointerEvents: 'none',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: 'none',
      },
    },
    innerwrapper: {
      position: 'relative',
      display: 'flex',
      width: 'calc(100% - 760px)',
      justifyContent: 'flex-start',
      height: '100%',
    },
  };
};
